/* @ngInject */
export default function ($scope, $stateParams, LayoutService, toastr, $state, FormResponses, DataTablesService, DocumentsService, PreferencesService, FormResponseService) {
	$scope.formId     = $stateParams.formId;
	$scope.responseId = $stateParams.responseId;

	$scope.DocumentsService = DocumentsService;
	$scope.dateTimeFormat   = PreferencesService.getDateTimePreference();

	$scope.loading    = true;
	$scope.submitting = false;

	$scope.refresh = () => {
		$scope.loading = true;

		FormResponses.one($scope.responseId)
		             .get({
			             include: 'version.form,version.elements,responseElements.element,user.workable',
		             })
		             .then((response) => {
			             $scope.response = response;
			             $scope.loading  = false;

			             $scope.updateLayout($scope.response.version.form.title);
		             })
		             .catch((error) => {
			             toastr.clear();
			             toastr.error('There was an error while loading this form response, please try again.', 'Error');

			             $state.go('staff.forms.responses.view.root', {
				             formId: $scope.formId,
			             });

			             $scope.loading = false;
		             });
	};

	$scope.submit = () => {
		if (!$scope.loading) {
			if (!$scope.submitting) {
				const errors = FormResponseService.validate($scope.response.version.elements);

				if (errors.length === 0) {
					$scope.submitting = true;

					const response = FormResponseService.getPostableResponse($scope.response.version);

					FormResponses.one($scope.responseId)
					             .customPUT(response)
					             .then((returnedResponse) => {
						             $scope.submitting = false;

						             toastr.clear();
						             toastr.success('Your form response was successfully saved.', 'Success');

						             $state.go('staff.forms.responses.view.root', {
							             formId: $scope.formId,
						             });
					             })
					             .catch((data) => {
						             $scope.submitting = false;

						             toastr.clear();
						             toastr.error('There was an error while submitting your form response, please check your input and try again.', 'Error');
					             });
				} else {
					let uniqueErrors = [
						...new Set(errors),
					];

					uniqueErrors = uniqueErrors.map((error) => {
						return `<li>${error}</li>`;
					});

					uniqueErrors = uniqueErrors.join('');

					toastr.clear();
					toastr.warning(`<ul>${uniqueErrors}</ul>`, 'Warning', {
						allowHtml: true,
					});
				}
			} else {
				toastr.clear();
				toastr.warning('You must wait for your form response to finish submitting.', 'Warning');
			}
		} else {
			toastr.clear();
			toastr.warning('You must wait for the form to load.', 'Warning');
		}
	};

	$scope.getResponseForElement = (element) => {
		const elementId = element.id;

		return $scope.response.responseElements.find((candidate) => {
			return candidate.element.id === elementId;
		});
	};

	$scope.updateLayout = (formName = 'Loading...') => {
		$scope.dtOptions = DataTablesService.configure({
			title: formName,
		}, {
			ordering: false,
		}).options;

		LayoutService.reset();

		LayoutService.setTitle([
			formName,
			'Responses',
			'Forms',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.forms.root',
				             displayName: 'Forms',
			             },
			             {
				             route:       'staff.forms.responses.root',
				             displayName: 'Responses',
			             },
			             {
				             route:       `staff.forms.responses.view.root({ formId: "${$scope.formId}" })`,
				             displayName: formName,
			             },
			             {
				             route:       `staff.forms.responses.view.edit({ formId: "${$scope.formId}", responseId: "${$scope.responseId}" })`,
				             displayName: 'Edit',
			             },
		             ]);

		const updateButton = LayoutService.getPageHeader()
		                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		const saveButton = LayoutService.getPageHeader()
		                                .setActionButton('<button type="button" class="btn btn-primary pull-right m-r"><i class="fa fa-check"></i> Save</button>');

		LayoutService.getPageHeader()
		             .onClicked(updateButton, $scope.refresh);

		LayoutService.getPageHeader()
		             .onClicked(saveButton, $scope.submit);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/forms/responses/view/edit/controller.js